import { createTheme as m } from "./highrise984.mjs";
import i from "./highrise1042.mjs";
import p from "./highrise1007.mjs";
import s from "./highrise987.mjs";
import { composite as a } from "./highrise993.mjs";
function c(r) {
  const {
    borderRadius: t,
    boxShadow2: e,
    baseColor: o
  } = r;
  return Object.assign(Object.assign({}, i), {
    borderRadius: t,
    boxShadow: e,
    color: a(o, "rgba(0, 0, 0, .85)"),
    textColor: o
  });
}
const g = m({
  name: "Tooltip",
  common: s,
  peers: {
    Popover: p
  },
  self: c
});
export {
  g as default
};
